import { useCallback, useEffect, useRef, useState } from 'react';
import { errorText } from './api';

/** Загрузка данных с перезапросом. key — когда менять, тогда грузить заново. */
export function useLoad<T>(load: () => Promise<T>, key: unknown[] = []) {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const seq = useRef(0);
  const run = useCallback(async () => {
    const n = ++seq.current;
    setLoading(true);
    try {
      const d = await load();
      if (n === seq.current) {
        setData(d);
        setError(null);
      }
    } catch (err) {
      if (n === seq.current) setError(errorText(err));
    } finally {
      if (n === seq.current) setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, key);
  useEffect(() => {
    void run();
  }, [run]);
  return { data, setData, error, loading, reload: run };
}

/** Опрос каждые ms, пока active. */
export function usePoll(fn: () => void, ms: number, active: boolean) {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    if (!active) return;
    const t = setInterval(() => ref.current(), ms);
    return () => clearInterval(t);
  }, [ms, active]);
}
